export default "__VITE_ASSET__BXIUN9vN__"